export default {
  cities: null,
  city: null,
  universities: null,
  university: null
};
